<template>
  <div>
    <DJI_RC_PLUS
      v-if="$root.from == 'DJI_RC_PLUS' || $root.from == 'DJI_RC_PLUS_2'"
    />
    <DJI_RC_PRO_E v-if="$root.from == 'DJI_RC_PRO_E'" />
  </div>
</template>

<script>
import DJI_RC_PLUS from "@/app/pilotlogin/DJI_RC_PLUS/DJI_RC_PLUS_HOME.vue";
import DJI_RC_PRO_E from "@/app/pilotlogin/DJI_RC_PRO_E/DJI_RC_PRO_E_HOME.vue";

export default {
  name: "APP_PILOTLOGIN",
  components: {
    DJI_RC_PLUS,
    DJI_RC_PRO_E,
  },
};
</script>
